import SurveyListPanel from './surveyListPanel.container'

export default SurveyListPanel;